"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithUser = exports.withUser = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const errors_1 = require("../errors");
const withUser = (Component, displayName) => {
    displayName = displayName || Component.displayName || Component.name || 'Component';
    Component.displayName = displayName;
    const HOC = (props) => {
        const user = (0, UserContext_1.useUserContext)();
        if (!user) {
            return null;
        }
        return (react_1.default.createElement(Component, Object.assign({}, props, { user: user })));
    };
    HOC.displayName = `withUser(${displayName})`;
    return HOC;
};
exports.withUser = withUser;
const WithUser = ({ children }) => {
    const user = (0, UserContext_1.useUserContext)();
    if (typeof children !== 'function') {
        throw new Error(errors_1.hocChildrenNotAFunctionError);
    }
    if (!user) {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children(user));
};
exports.WithUser = WithUser;
